import CONSTANTS from 'utils/constants';
import DataTransformer from 'wixPaste/DataTransformer';
import _ from 'ckLodash';
import guardUtils from 'utils/guardUtils';
import htmlEquivalentComparer from 'namespace/htmlEquivalentComparer';
import isValidHtml from 'namespace/isValidHtml';
import selectionUtils from 'utils/selectionUtils';
import setDataWithSelection from 'utils/setDataWithSelection';
import setInvalidHtml from 'namespace/setInvalidHtml';
import styleUtils from 'utils/styleUtils';

function prepareForSetHtml(editor, data) {
    data = data.replace(/<font (.*?)>/g, function (match, group1) {
        var prefix = '<span style="';
        var suffix = '">';
        var styles = group1
            .replace(/size="(.*?)"/g, '')
            .replace('=', ':')
            .replace(/" /g, '";')
            .replace(/"/g, '')
            .replace(/face/g, 'font-family');
        return prefix + styles + suffix;
    }).replace(/<\/font>/g, '</span>');
    data = _.trim(data).length === 0 ? '<p class="font_8"></p>' : data;
    data = guardUtils.transformGuardForSetData(data);
    data = editor.dataProcessor.toHtml(data);
    return data;
}

function setHtml(editor, data) {
    data = data || '<p class="font_8"><span class="wixGuard">' + CONSTANTS.WIX_GUARD + '</span></p>';
    data = prepareForSetHtml(editor, data);
    editor.editable().setHtml(data);
    if (editor.editable().getText().trim().length === 0) {
        let blockElement = editor.editable().findOne('p,h1,h2,h3,h4,h5,h6,blockquote');
        guardUtils.insertGuard(editor, blockElement);
    }
    editor.fire('change');
}

function _isValidHtml(editor, htmlOriginal) {
    if (!htmlOriginal) {
        return false;
    }
    let htmlEquivalentComparerResult;
    let htmlResult;
    try {
        htmlOriginal = htmlOriginal.replace(/[\n\r\t]/mg, '');
        htmlResult = prepareForSetHtml(editor, htmlOriginal);
        htmlResult = new DataTransformer(htmlResult, true, editor)
            .fixOrphans()
            .getHtml();
        htmlEquivalentComparerResult = htmlEquivalentComparer(htmlOriginal, htmlResult, false, true);
    } catch (e) {
        CKEDITOR.error(e);
        return false;
    }
    const isValid = htmlEquivalentComparerResult.pass && isValidHtml(htmlResult);
    return isValid;
}

function setData(editor, data, {validateHtml, callback = _.noop, removeNestedStyles = false} = {}) {
    data = data || '<p class="font_8"><span class="wixGuard">' + CONSTANTS.WIX_GUARD + '</span></p>';
    data = data.replace(/[\n\t\r]/g, '');

    if (removeNestedStyles) {
        data = styleUtils.removeNestedStyles(data);
    }

    if (!validateHtml || _isValidHtml(editor, data)) {
        setHtml(editor, data);
        callback();
    } else {
        setInvalidHtml(editor, data, callback, setHtml);
    }
}

function init(editor) {
    editor.WIX = {
        TestUtils: {
            setDataWithSelection: setDataWithSelection.setData
        },
        getData: function () {
            return editor.getData();
        },
        isMultipleBlockSelection: function () {
            return selectionUtils.isMultipleBlockSelection(editor);
        },
        setDataWithSelectionAt: (data, {
            validateHtml,
            cursorLocation = CONSTANTS.CURSOR_LOCATIONS.START,
            callback = _.noop,
            removeNestedStyles = false
        } = {}) => {
            const setDataCB = () => {
                selectionUtils.setSelectionAt(editor, cursorLocation);
                editor.undoManager.save();
                callback();
            };

            setData(editor, data, {validateHtml, callback: setDataCB, removeNestedStyles});
        },
        setHtmlWithSelectAll: (data, {validateHtml, callback = _.noop, removeNestedStyles = false} = {}) => {
            setData(editor, data, {validateHtml, callback, removeNestedStyles});
            selectionUtils.setSelectionAt(editor, CONSTANTS.CURSOR_LOCATIONS.ALL);
            editor.undoManager.save();
        },
        setHtml: _.partial(setHtml, editor),
        setData: _.partial(setData, editor),
        hasSelection: () => !selectionUtils.isSelectedTextEmpty(editor),
        isAllSelected: () => selectionUtils.isAllSelected(editor),
        isValidHtml: _.partial(_isValidHtml, editor)
    };
}

export default {
    init
};
